import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field', 'hint']

  connect () {
    this.fieldTarget.addEventListener('input', this.#toggleHint.bind(this))
  }

  #toggleHint () {
    this.fieldTarget.value > 84 ? this.#showHint() : this.#hideHint()
  }

  #showHint () {
    this.hintTarget.classList.remove('hidden')
  }

  #hideHint () {
    this.hintTarget.classList.add('hidden')
  }
}
